import _extends from "@babel/runtime/helpers/esm/extends";
import PropTypes from 'prop-types';
import React, { forwardRef } from 'react';
import { StyledVerticalNavList } from './VerticalNavList.styles';

/**
 * Acts as a wrapper for `VerticalNav.Item` components.
 *
 * @since 8.72.0
 */

export var VerticalNavList = /*#__PURE__*/forwardRef(function (props, forwardedRef) {
  return /*#__PURE__*/React.createElement(StyledVerticalNavList, _extends({
    ref: forwardedRef
  }, props));
});
VerticalNavList.displayName = 'VerticalNavList';
VerticalNavList.propTypes = {
  /**
   * A group of `VerticalNav.Item` components.
   */
  children: PropTypes.node.isRequired,
  /**
   * Use the styled-components
   * [polymorphic "as" prop](https://www.styled-components.com/docs/api#as-polymorphic-prop)
   * to change the HTML tag of the component.
   *
   * This can be used to apply `Button` styling to HTML anchors, inputs, and custom components.
   */
  // eslint-disable-next-line zillow/react/forbid-prop-types
  as: PropTypes.any
};
VerticalNavList.defaultProps = {};